import React, { useEffect, useMemo, useState } from "react";
import useDoctorDashboardStore from "modules/all_doctor_dashboard/store";
import DoctorInputFilter from "modules/all_doctor_dashboard/DoctorInputFilter";
import DoctorPrescriptionTable from "modules/all_doctor_dashboard/DoctorPrescriptionTable";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CardDiv from "modules/common/card-div/CardDiv";

function DoctorDashboard() {
  const {
    dashboardData,
    dashboardLoading,
    fetchDashboardData,
    fetchDoctorDashboardData,
  } = useDoctorDashboardStore();
  const [queryParams, setQueryParams] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageData = searchParams.get("pageNo");
  const [page, newPage] = useState(pageData);

  const currentUrl = window.location.href;

  const urlQuery = useMemo(() => {
    return currentUrl.split("home")[1];
  }, [currentUrl]);

  useEffect(() => {
    if (!urlQuery) {
      return;
    }
    fetchDashboardData(urlQuery, newPage);
  }, [urlQuery, queryParams]);

  useEffect(() => {
    if(queryParams){
      navigate(`/home?${queryParams}&pageNo=${page}`);
    }
    else if (page) {
      navigate(`/home?pageNo=${page}`);
    }
  }, [page]);

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between align-items-center gap-3">
            <div className="fs-2 text-nowrap">Assigned Orders</div>
            <DoctorInputFilter setQueryParams={setQueryParams} newPage={newPage} />
          </div>
        }
        component={
          <DoctorPrescriptionTable
            dashboardData={dashboardData}
            dashboardLoading={dashboardLoading}
            newPage={newPage}
            page={page}
          />
        }
      />
    </div>
  );
}

export default DoctorDashboard;
